<template>
  <div class="footer-nav" :class="className">
    <v-touch @tap="prev" @doubletap="preventZoom">
      <div class="icon-arrow-left4 no-print left-button"></div>
    </v-touch>
    <v-touch @tap="$emit('today')" class="today-button" :class="{notActive: !isNotToday}">
      <div class="center-button">{{ $t('repitition.today')}}</div>
    </v-touch>
    <v-touch @tap="next">
      <div class="icon-arrow-right4 no-print right-button"></div>
    </v-touch>
  </div>
</template>

<script>
  import eventBus from '../../../eventbus'
  export default {
    props: {
      isNotToday: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      className () {
        return eventBus.sideWideAnnouncement ? 'true' : ''
      }
    },
    methods: {
      prev (e) {
        e.preventDefault()
        this.$emit('prev')
      },
      next (e) {
        e.preventDefault()
        this.$emit('next')
      },
      preventZoom (e) {
        e.preventDefault()
      }
    }
  }
</script>

<style scoped>
  @import '../../../assets/css/variables.css';

  .footer-nav {
    display: flex;
    position: fixed;
    z-index: 500;
    left: 0;
    right: 0;
    bottom: 0;
    background: white;
    border-top: 1px solid #d9d9d9;
  }
  .footer-nav.true {
    bottom: 50px;
  }

  .footer-nav div {
    display: flex;
    height: 55px;
    line-height: 55px;
    justify-content: center;
    cursor: pointer;
    font-weight: bold !important;
    color: var(--blue);
    font-size: 16px;
    flex: 2;
  }

  .footer-nav .left-button {
    border-right: 1px solid #d8d8d8;
  }

  .footer-nav .right-button {
    border-left: 1px solid #d8d8d8;
  }

  .footer-nav .center-button {
    font-size: 14px;
    font-weight: normal !important;
  }

  .footer-nav .today-button {
    flex: 1;
  }

  .footer-nav div.notActive > div {
    color: #cccccc !important;
  }
</style>



// WEBPACK FOOTER //
// FooterNav.vue?0d1faeba